import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IMobileApp {
  id?: number;
  page_id?: number;
  component_id?: number;
  title?: string;
  title_text_color?: string;  // Added
  desktop_bg_image?: string;
  mobile_bg_image?: string;
  alt_image?: string;
  video_link?: string;
  google_play_icon?: string;  // Added
  google_play_icon_alt?: string;  // Added
  google_play_link?: string;  // Added
  app_store_icon?: string;  // Added
  app_store_icon_alt?: string;  // Added
  app_store_link?: string;  // Added
  background_color?: string;  // Added
  is_blog?: boolean;
  status?: boolean;
  variant?: string;
}

export async function createMobileApp(payload: Partial<IMobileApp>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.MOBILE_APP.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateMobileApp(id: number, payload: Partial<IMobileApp>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.MOBILE_APP.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
